module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pl-dialog', {
    attrs: {
      "title": 'Course Sync',
      "headerStyle": 'text-align: center; font-weight:bold',
      "disableOutsideClick": true,
      "size": 'sm'
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "my-3 px-7"
  }, [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "course-modal-content flex-grow overflow-y-auto py-3 px-7"
  }, [_c('div', {
    staticClass: "flex justify-center",
    staticStyle: {
      "max-height": "calc(80vh - 220px)",
      "overflow-y": "auto"
    }
  }, [_c('ul', _vm._l((_vm.courses_I_teach), function(course, index) {
    return _c('li', {
      key: course.id,
      staticClass: "flex flex-nowrap items-center w-100",
      on: {
        "click": function($event) {
          return _vm.selectCourse(index)
        }
      }
    }, [_c('div', [_c('pl-checkbox', {
      attrs: {
        "value": course
      },
      on: {
        "change": function($event) {
          return _vm.selectedCourses()
        }
      },
      model: {
        value: (_vm.selectedCourses),
        callback: function($$v) {
          _vm.selectedCourses = $$v
        },
        expression: "selectedCourses"
      }
    })], 1), _vm._v(" "), _c('div', [_c('label', {
      attrs: {
        "for": course.title
      }
    }, [_vm._v("\n                " + _vm._s(_vm._f("truncate")(course.title, 26)) + "\n                " + _vm._s(course.sections[0] ? ' - ' : '') + "\n                " + _vm._s(_vm._f("truncate")(course.sections[0], 10)) + "\n                "), (course.is_archived) ? [_c('span', {
      staticClass: "ruby"
    }, [_vm._v(" (Archived) ")])] : _vm._e()], 2)])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "my-5 center items-center"
  }, [_c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.confirmSync
    }
  }, [_vm._v("\n        Confirm Sync\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-70bc6095!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/schoolCoursesModal.vue
// module id = 2415
// module chunks = 61